<template>
  <el-dialog
    :title="title || '提示'"
    :visible.sync="visible"
    width="378px"
    top="25vh"
    center
    show-close
    class="msg-dialog__outer"
  >
    <div class="content">{{ msg }}</div>
    <span slot="footer">
      <el-button class="btn btn-cancel" plain @click="onCancel" v-if="cancelText">{{ cancelText }}</el-button>
      <el-button class="btn" type="primary" @click="onConfirm" v-if="confirmText">{{ confirmText }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'msg-dialog',
  data() {
    return {
      visible: false,
      resolve: undefined,
      reject: undefined,
      title: '提示',
      msg: 'Hello',
      cancelText: undefined,
      confirmText: '我知道了'
    };
  },
  methods: {
    $show() {
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
        this.visible = true;
      });
    },
    _reset() {
      this.visible = false;
    },
    onCancel() {
      this._reset();
      this.reject && this.reject('cancel');
    },
    onConfirm() {
      this._reset();
      this.resolve && this.resolve();
    }
  }
};
</script>

<style lang="scss">
.msg-dialog__outer {
  .content {
    margin: 0 auto;
    text-align: center;
  }
  /deep/.el-dialog__headerbtn {
    display: block !important;
  }
  .btn-cancel {
    color: #1e8dff !important;
    background: #fff !important;
  }
  .btn {
    width: 132px;
  }
}
</style>
